import * as React from 'react';

import { IProps } from './interfaces';

import styles from './LanguageSwitcher.module.styl';

const LanguagesList = (props: IProps) => {
  const { languages } = props;

  return (
    <div className={styles.root}>
      {languages.split(',').map((locale: string) => (
        <span
          key={locale}
          title={locale}
          className={styles[locale] || styles.noLocale}
        >
          <span>{locale}</span>
        </span>
      ))}
    </div>
  );
};

export default LanguagesList;
